import React from "react";

import { SetupProvider } from "./context/SetupContext";
import { useSetup } from "./hooks/useSetup";
import { getFlowSteps } from "./flowConfig";

import SetupLayout from "./components/SetupLayout";
import WelcomeStep from "./components/WelcomeStep";
import CompanyStep from "./components/CompanyStep";
import WhatsappStep from "./components/WhatsappStep";
import ChooseAIStep from "./components/ChooseAIStep";
import TrainingStep from "./components/TrainingStep";
import CatalogStep from "./components/CatalogStep";
import PaymentStep from "./components/PaymentStep";
import SchedulingServicesStep from "./components/SchedulingServicesStep";
import SchedulingProfessionalsStep from "./components/SchedulingProfessionalsStep";
import SchedulingAvailabilityStep from "./components/SchedulingAvailabilityStep";
import TestStep from "./components/TestStep";
import ReadyStep from "./components/ReadyStep";
import FinishStep from "./components/FinishStep";

const STEP_COMPONENTS = {
  welcome: WelcomeStep,
  company: CompanyStep,
  whatsapp: WhatsappStep,
  chooseAI: ChooseAIStep,
  training: TrainingStep,
  catalog: CatalogStep,
  payment: PaymentStep,
  schedulingServices: SchedulingServicesStep,
  schedulingProfessionals: SchedulingProfessionalsStep,
  schedulingAvailability: SchedulingAvailabilityStep,
  test: TestStep,
  ready: ReadyStep,
  finish: FinishStep
};

function Flow() {
  const { currentStep, nextStep, ai } = useSetup();

  const flowSteps = getFlowSteps(ai?.objective);
  const stepName = flowSteps[currentStep] || "welcome";
  const StepComponent = STEP_COMPONENTS[stepName] || WelcomeStep;

  if (stepName === "welcome") {
    return <StepComponent onContinue={nextStep} />;
  }

  return <StepComponent />;
}

export default function SetupFlow() {
  return (
    <SetupProvider>
      <SetupLayout>
        <Flow />
      </SetupLayout>
    </SetupProvider>
  );
}
